import $ from "jquery";
import { gsap } from "gsap";

$(function() {

    $('a[href$="#"]').click(function(e) {
        e.preventDefault();
    });

    const _about_video = $('.about_video_inner');
    // const _about_videoH = _about_video.height();
    let _v = true;
    // _about_video.height(0);
    _about_video.slideUp(0);
    $('.btn_txt.close').hide();
    $('.video_btn').click(function() {
        if (_v) {
            $('.btn_txt.open').hide();
            $('.btn_txt.close').show();
            $('.video_btn_arrow_img').css('transform', 'rotate(-90deg)');
            // gsap.to(_about_video, { duration: .6, height: _about_videoH, ease: 'quart.out' });
            _about_video.slideDown();
            $('.video').find('iframe').focus();
        } else {
            $('.btn_txt.open').show();
            $('.btn_txt.close').hide();
            $('.video_btn_arrow_img').css('transform', 'rotate(0deg)');
            // gsap.to(_about_video, { duration: .6, height: 0, ease: 'quart.out' });
            _about_video.slideUp();
        }
        _v = !_v;
    });
});